import Vue from 'vue'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronCircleLeft } from '@fortawesome/pro-regular-svg-icons'
import { faCaretRight } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronCircleLeft,faCaretRight)

//@ts-ignore
import SlideUpDown from 'vue-slide-up-down'

import {getParameterByName} from './util'
import {visitorLocaleImpliesGDPR} from './localize'

import {CmpApi} from '@iabtcf/cmpapi';
import {TCModel, TCString, GVL} from '@iabtcf/core/lib';

// @ts-ignore
import { local, session, options } from 'brownies';
var cookies = require('browser-cookies');

// cookies[options] = {
//   expires: 365 * 24 * 60 * 3600,
//   autoencode: false,
// };

const CMP_BUILD = 255;
const CMP_ID = 77;
const CMP_VERSION = 1;
const CMP_CONSENTCOOKIE = "euconsent-v2";
const CMP_NONTCFCONSENTCOOKIE = "euconsent-v2-non-tcf";

declare const gGDPR_publisherCountryCode: string;
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

declare let __tcfapi : any;

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('slide-up-down', SlideUpDown)

Vue.config.productionTip = false

GVL.baseUrl = "https://qd.admetricspro.com/js/cmp2";

GVL.baseUrl = "https://qd.admetricspro.com/js/cmp2/archive";
// GVL.latestFilename = 'vendor-list-v44-plus-google.json';        // Works!
// GVL.latestFilename = 'vendor-list-v52.json';      // Uh Oh!

GVL.latestFilename = 'vendor-list-test.json';   
  
//
// Always initialize the CMP as we need to return GDPR does not
// apply if we're not in a GDPR geography.
//

//@ts-ignore
let cmpApi = window.__cmpAPI = new CmpApi( CMP_ID, CMP_VERSION, false );

function __injectDOMElements( mountDivID : string ) : void {
  // console.log("__injectDOMElements()");
  // console.log(">>>> Preparing to inject mounting div at end of body element");

  let existingMountDiv = document.getElementById(mountDivID);

  if ( existingMountDiv ) {
    // console.log("+++ Mount div exists, nothing to do");

  }
  else {
    // console.log("!!! Mount div DOES NOT exist, trying to inject it");
    let bodyElement = document.getElementsByTagName('body')[0];
    bodyElement.innerHTML = bodyElement.innerHTML + "<div id="+mountDivID+"></div>";
    }

  // console.log(">>>> After injecting mounting div at end of body element");

  // Inject footer and privacy policy pages to resurface the GDPR...

  setTimeout( () => {
    // console.log(">>>> Preparing to inject code inside footer and privacy page divs (if they exist)");

    let onClickCommand = "window.scroll(0,0);__cmpOpenUI('layerTwo')"; 

    let privacyElem = document.getElementById('ampCMP_privacyPolicy');
    if ( privacyElem)
      privacyElem.innerHTML = '<h4>Privacy Consent Management</h4><p>You can resurface the consent management platform that will allow you to edit and change your consent choices by clicking this link: <a href="javascript:void(0);" onclick="'+onClickCommand+'">Manage Your Consent</a></p>';
    
    let footerElem = document.getElementById('ampCMP_footer');
    if ( footerElem) {
      footerElem.innerHTML = '<a class="nav-link" href="javascript:void(0);" onclick="'+onClickCommand+'">Privacy Choices</a>';
    }

    // console.log(">>>> After injecting code inside footer and privacy page divs");
    
  }, 500);

}


function __cmpGetExistingConsent() : string {
  let cookie = getCookie( CMP_CONSENTCOOKIE );
  
  if (cookie)
    console.log("CMP: Found existing consent string in cookie")
  else {
    cookie = local[CMP_CONSENTCOOKIE];
    if (cookie)
      console.log("CMP: Found existing consent string in local storage")
    else {
      cookie = session[CMP_CONSENTCOOKIE];
      if ( cookie )
        console.log( "CMP: Found existing consent string in session storage")
      else
        console.log( "CMP: No existing consent found in cookie, local or session storage")
    }
  }

  if (cookie)
    console.log( cookie )
    console.log("CMP: checking non TCF vendor cookie")

    let nonTCFCookie = getCookie( CMP_NONTCFCONSENTCOOKIE );

    if (nonTCFCookie)
      console.log("CMP: Found existing non-TCF consent string in cookie")
    else {
      nonTCFCookie = local[CMP_NONTCFCONSENTCOOKIE];
      if (nonTCFCookie)
        console.log("CMP: Found existing non-TCF consent string in local storage")
      else {
        nonTCFCookie = session[CMP_NONTCFCONSENTCOOKIE];
        if ( nonTCFCookie )
          console.log( "CMP: Found existing non-TCF consent string in session storage")
        else
          console.log( "CMP: No existing non-TCF consent found in cookie, local or session storage")
      }
    }

    if ( gGDPR_NonTCFVendors && nonTCFCookie ) {

      let consentedVendors = nonTCFCookie.split("-");
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      // @ts-ignore

      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = false;

      var arrayLength = consentedVendors.length;
      for (var i = 0; i < arrayLength; i++) {
      // @ts-ignore
      if ( gGDPR_NonTCFVendors[index].name == consentedVendors[i])
      // @ts-ignore
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
      }
      
      });
    }
  
// console.log("FORCING COOKIE")
//     cookie='COvFyGBOvFyGBAbAAAENAPCAAOAAAAAAAAAAAEEUACCKAAA.IFoEUQQgAIQwgIwQABAEAAAAOIAACAIAAAAQAIAgEAACEAAAAAgAQBAAAAAAAGBAAgAAAAAAAFAAECAAAgAAQARAEQAAAAAJAAIAAgAAAYQEAAAQmAgBC3ZAYzUw'

  return cookie;
}


function __uspClearConsent( ) : void {
  if (getParameterByName( "cmpClearConsent" ) ) {
    let cookie = getCookie( CMP_CONSENTCOOKIE );

    if (cookie) {
      console.log("CMP: Found and removing existing consent string in cookie")
      console.log( cookie)
      // delete cookies[CMP_CONSENTCOOKIE];
      cookies.erase(CMP_CONSENTCOOKIE)
    }

    cookie = local[CMP_CONSENTCOOKIE];

    if (cookie) {
      console.log("CMP: Found and removing existing consent string in local storage")
      console.log( cookie)
      delete local[CMP_CONSENTCOOKIE];
    }

    cookie = session[CMP_CONSENTCOOKIE];

    if (cookie) {
      console.log("CMP: Found and removing existing consent string in session")
      console.log( cookie)
      delete session[CMP_CONSENTCOOKIE];
    }

    if ( gGDPR_NonTCFVendors ) {
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      // @ts-ignore
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = false;
      });
    }
  
    cookies.erase(CMP_NONTCFCONSENTCOOKIE)
    delete local[CMP_NONTCFCONSENTCOOKIE];
    delete session[CMP_NONTCFCONSENTCOOKIE];
  
  }


}


  // Docs for this from https://github.com/InteractiveAdvertisingBureau/iabtcf-es/tree/master/modules/core#iabtcfcore
  

  // This function gets called from the UI code to save the tcString when it changes.
  // We're hosting it here so that it's in one spot with all the cookie/storage retrieval
  // code also in this file...


  function setCookieWithExpireTime ( key:string, value:string, days:number) : void {

    // irritating that we have to do this browser-cookies code instead of the brownies cookies library...
    // There seems to be no way to disable encoding of the stored value so the stored cookie
    // is useless to outside parties unless they know the cookie is encoded. autoencode: false
    // doesn't seem to fix this.

    // console.log( "SET COOKIE "+ key + " = " + value + " days="+days)

    cookies.set( key, value, {expires:days} );
}

function getCookie ( key:string ) : string {

  // irritating that we have to do this browser-cookies code instead of the brownies cookies library...
  // There seems to be no way to disable encoding of the stored value so the stored cookie
  // is useless to outside parties unless they know the cookie is encoded. autoencode: false
  // doesn't seem to fix this.

  return cookies.get( key, );
}

function __storeTCString( ) : void {
    // @ts-ignore
    window.__cmpTCModel.updated();
  
    // @ts-ignore
    const encodedString = TCString.encode(window.__cmpTCModel);
  
    // console.log( "storeTCString() " + encodedString)
  
    setCookieWithExpireTime(CMP_CONSENTCOOKIE, encodedString, 365 );
    // cookies[CMP_CONSENTCOOKIE] = encodedString;
    local[CMP_CONSENTCOOKIE] = encodedString;
    session[CMP_CONSENTCOOKIE] = encodedString;

    let consentString = "";

    if ( gGDPR_NonTCFVendors ) {
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      // @ts-ignore
      if ( gGDPR_NonTCFVendors[index].modelConsent ) {
        // @ts-ignore
        gGDPR_NonTCFVendors[index].consent = true;
          
        if (consentString)
          consentString = consentString + "-";

        // @ts-ignore
        consentString = consentString + gGDPR_NonTCFVendors[index].name;
        }
      });
    }
    console.log( "storeTCString() " + consentString)

    setCookieWithExpireTime(CMP_NONTCFCONSENTCOOKIE, consentString, 365 );
    // cookies[CMP_NONTCFCONSENTCOOKIE] = consentString;
    local[CMP_NONTCFCONSENTCOOKIE] = consentString;
    session[CMP_NONTCFCONSENTCOOKIE] = consentString;
    // console.log("calling cmpApi.update()...")
    // console.log(encodedString)
    //@ts-ignore
    cmpApi.update(encodedString);
    // console.log(" cmpApi.update() completed")


    // __tcfapi('getTCStatus', 2, (status: any,result: any) => {
    //   console.log( "__storeTCString status check 1:" );
    //   console.log( status );
    //   console.log( result );
    // });


  }         


  function __uspLaunch( ) {

    console.log( "__uspLaunch begin" );

    //   // @ts-ignore
    //   window.__tcfapi('addEventListener', 2, (tcData, success) => {
    //     console.log(' __uspLaunch(): eventListener:' + success );

    //     if (success)
    //       {
    //       console.log(tcData);

    //       // @ts-ignore
    //       window.__tcfapi('getTCData', 2, (tcData, success) => { 
    //         if (success) {
    //           console.log(' __uspLaunch(): eventListener >> getTCData success' );
    //           console.log(tcData);
    //           }
    //           else
    //           console.log(' __uspLaunch(): eventListener >> getTCData FAILED' );

    //         })
    //       }
    //       else
    //       console.log(' __uspLaunch(): eventListener FAILED' );

    // });



    __uspClearConsent();

    let cookie = __cmpGetExistingConsent();
    let needNewConsent = true;
    if ( cookie  ) {

        // @ts-ignore
        // let saveGVL : GVL = window.__cmpTCModel.gvl;  // Wow, the need for this is really some stupid here.
        //@ts-ignore
        // window.__cmpTCModel = TCString.decode(cookie, window.__GVL );
        
        window.__cmpTCModel = TCString.decode( cookie );

        //@ts-ignore
        let currentVendorListVersion = window.__GVL.vendorListVersion;
        //@ts-ignore
        let consentVendorVersion = window.__cmpTCModel.vendorListVersion;
        //@ts-ignore
        let consentCmpVersion = window.__cmpTCModel.cmpVersion;

        if ( currentVendorListVersion < consentVendorVersion ) {
          console.log( "CMP: Existing consent vendor list " +consentVendorVersion + " less than current " + currentVendorListVersion  );
        }
        else if ( consentCmpVersion < CMP_VERSION ) {
          console.log( "CMP: Existing consent CMP version  " +consentCmpVersion + " less than current " + CMP_VERSION  );
        }
        else  {
          needNewConsent = false;
        //@ts-ignore
        window.__cmpTCModel = TCString.decode( cookie, window.__GVL );
          cmpApi.update(cookie);
        }
      } 
      
      if ( needNewConsent ) {
        //@ts-ignore
        window.__cmpTCModel.unsetAll();
        //@ts-ignore
        window.__cmpTCModel.setAllVendorsDisclosed();
        cmpApi.update(cookie, true); // tell the CMP api we don't have consent yet, but we're showing the UI
      }

      // __tcfapi('getTCStatus', 2, (status: any,result: any) => {
      //   console.log( "__uspLaunch status check 1:" );
      //   console.log( status );
      //   console.log( result );
      // });
      


    let targetLayer : string = "close";

    if ( getParameterByName( "cmpForceUI" ) ) {
      console.log( "CMP: cmpForceUI URL parameter present, forcing UI to open in geography");
      targetLayer = "layerOne";
    }

    if ( visitorLocaleImpliesGDPR() ) {
      if (! cookie ) {
        console.log( "CMP: GDPR applies and no existing consent")
        targetLayer = "layerOne";
      } else     
        console.log( "CMP: GDPR applies, using existing consent")
    }
    else
    {
      console.log( "CMP: GDPR does not apply ")
      cmpApi.update(null);
      return;
    }

    if (targetLayer=="close")
      return;

    // window.addEventListener('load', (event) => {
    //   __cmpOpenUI( targetLayer );
    //   } );

    setTimeout( () => { __cmpOpenUI( targetLayer ); }, 250 );

  }

  // @ts-ignore
  let vueInstance: App = undefined;

  // @ts-ignore
  window.__GVL = new GVL();
  // @ts-ignore
  window.__cmpTCModel = new TCModel( window.__GVL );
  
  // @ts-ignore
  window.__cmpTCModel.cmpId = CMP_ID;
  // @ts-ignore
  window.__cmpTCModel.cmpVersion = CMP_VERSION;
  // @ts-ignore
  window.__cmpTCModel.consentScreen = 1;
  // @ts-ignore
  window.__cmpTCModel.isServiceSpecific = true;
  // @ts-ignore
  window.__cmpTCModel.publisherCountryCode = gGDPR_publisherCountryCode ? gGDPR_publisherCountryCode : 'US';

  
  function __cmpOpenUI( targetLayer:string ) {

    // Show the UI. Code inside the app handles encoding the consent string and calling
    //  cmpApi.update() when it changes...
  
    console.log( "__cmpOpenUI()" );

    if ( ! vueInstance ) {
      // console.log( "__cmpOpenUI():   ! vueInstance" );
      const mountDivID = "__cmp_mount";

      // window.addEventListener('DOMContentLoaded', (event) => {
      // document.addEventListener('load', (event) => {
      // document.addEventListener('DOMContentLoaded', (event) => {
      
      __injectDOMElements( mountDivID );

      Vue.nextTick( () => {
        // console.log( "__cmpOpenUI():  nextTick" );
        const mountDivID = "__cmp_mount";

      // @ts-ignore
      vueInstance = new Vue({
        data: { initialLayer:targetLayer, cmpApi: cmpApi, storeTCString: __storeTCString },
        render: h => h(App),
      }).$mount('#' + mountDivID );

      } );

    } else {
      // console.log( "__cmpOpenUI():  calling handleChangeView" );

    // vueInstance.$emit('changeViewEvent', targetLayer);    /// <<<< This doesn't work for some reason

    // @ts-ignore
    vueInstance.$children[0].handleChangeView( targetLayer );

    // // @ts-ignore
    // vueInstance.$children[0].visible = (targetLayer == "close") ? false : true;            
    // // @ts-ignore
    // vueInstance.$children[0].view = targetLayer;

    // document.getElementsByTagName("body")[0].style.overflow = (targetLayer != "close") ? "hidden" : "initial";
    // document.getElementsByTagName("body")[0].style.height = (targetLayer != "close") ? "100vh" : "initial";
  
    }
    
  }

// @ts-ignore
window.__cmpOpenUI  = __cmpOpenUI;


// TODO: Handle non-tcf vendors getting read from and stored in the cookie/local/session in this file
// TODO: gGDPR_publisherCountryCode default if not present (throws presently)
// TODO: gGDPR_NonTCFVendors same as above
// TODO: Scroll to top and disable scroll when CMP is surfaced --> Undo when closed

console.log( "%cCMP: Startup v" + CMP_BUILD, 'color: #555599')


function waitForCMPLoad() {

  var pingCallback = function( pingResult: { cmpLoaded: any; cmpStatus: string } ) {

    // console.log( "CMP: ping Responded")
    // console.log( pingResult )
    
      if ( pingResult.cmpLoaded && (pingResult.cmpStatus == "loaded") )
          __uspLaunch();
      else {
        console.log( "CMP: waiting for ping loaded state")
        setTimeout( waitForCMPLoad, 50 );
      }
  }

  if ( __tcfapi )
      __tcfapi('ping', 2, pingCallback );
  else {
    console.log( "CMP: waiting for __tcfapi")
    setTimeout( waitForCMPLoad, 50 );
  }
}

// @ts-ignore
window.__cmpTCModel.gvl.readyPromise.then( () => { 
      // @ts-ignore
      console.log( "%cCMP: GVL version is " + window.__GVL.vendorListVersion, 'color: #555599')

      __uspLaunch(); 

} );

////////////////////////////////////
///
/// NOTES
///
///


// Console command to see if the CMP is loaded and alive...
//
// __tcfapi('ping', 2, (pingReturn: any) => { console.log( pingReturn ); });


//  TCModel GitHub docs...
//
//     https://github.com/InteractiveAdvertisingBureau/iabtcf-es/tree/master/modules/core#tcmodel


//  What's stored in the TCString...
//
//     https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20Consent%20string%20and%20vendor%20list%20formats%20v2.md#what-information-is-stored-in-a-tc-string


// Online TC String decoder...
//
// https://iabtcf.com/?#/decode


// Test Page
//
// https://www.dadsworksheets.com/test/cmp2.html?cmpForceLocale=fr-fr&cmpForceUI=1&cmpClearConsent=1


// Test Page 2
//
// https://www.dadsworksheets.com/test/cmp2.html?cmpForceLocale=fr-fr
//
// https://www.dadsworksheets.com/test/cmp2.html?cmpForceLocale=fr-fr&cmpClearConsent=1

